import ReactTooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";
import "./style.css";
import TooltipHelper from "../TooltipHelper";
import { useState, useRef, isValidElement } from "react";

export interface TooltipProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  /**
   * 是否支持 hover 显示， 默认click
   */
  hover?: boolean;
  /**
   * 是否显示箭头
   */
  arrow?: boolean;
  /**
   * 提示内容
   */
  content: React.ReactNode;
  /**
   * 提示位置
   */
  placement?:
    | "top"
    | "left"
    | "right"
    | "bottom"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom";
  /**
   * 根节点类名
   */
  className?: string;
  /**
   * 延迟显示时间 default: 0
   */
  mouseEnterDelay?: number;
  /**
   * 延迟隐藏时间 default: 0.1
   */
  mouseLeaveDelay?: number;
  /**
   * 是否可见
   */
  visible?: boolean;
  /**
   * 可见变化的cb
   */
  onVisibleChange?: (visible: boolean) => void;
  /**
   * 隐藏后销毁
   */
  destroyTooltipOnHide?: boolean;
  /**
   * align
   */
  align?: AlignType;
  onlyShowWhenOverflow?: boolean;
  tooltipHelper?: React.ReactElement<
    any,
    string | React.JSXElementConstructor<any>
  >;
  builtinPlacements?: any;
}

export type OffsetType = number | `${number}%`;
interface AlignType {
  offset?: OffsetType[];
}

function Tooltip(props: TooltipProps) {
  const {
    arrow = true,
    placement = "top",
    hover = true,
    className,
    mouseEnterDelay,
    mouseLeaveDelay,
    visible,
    onVisibleChange,
    destroyTooltipOnHide,
    align,
    onlyShowWhenOverflow,
    tooltipHelper,
    builtinPlacements
  } = props;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
const [showTooltip, setShowTooltip] = useState(false);
const [oldVisible, setOldVisible] = useState(false);

  const onShowTooltipChange = (newValue: boolean) => {
    setShowTooltip(newValue)
  };
  const trigger: any = hover
  ? ["hover", "click"]
  : ["click"];

  const onOldVisibleChange = (newValue: boolean)=>{
    onVisibleChange && onVisibleChange(newValue);
    setOldVisible(newValue);
  }
  const myVisible = onlyShowWhenOverflow ? showTooltip && oldVisible : visible;
  const otherProps = builtinPlacements ? { builtinPlacements } : {};
  const childRef = useRef<HTMLElement>(null);

  // 确保 children 能够接收 ref，避免 findDOMNode 警告
  // 如果 children 是原生 DOM 元素（type 是字符串），可以直接使用
  // 否则需要用可接收 ref 的元素包裹
  const wrappedChildren = isValidElement(props.children) && 
    typeof props.children.type === 'string' ? (
      // 原生 DOM 元素，可以直接使用
      props.children
    ) : (
      // 函数组件或类组件，用 span 包裹以确保可以接收 ref
      <span ref={childRef} style={{ display: 'inline-flex', alignItems: 'center' }}>
        {props.children}
      </span>
    );

  return (
    <>
      <ReactTooltip
        placement={placement}
        showArrow={arrow}
        trigger={trigger}
        overlay={props.content}
        overlayClassName={className}
        mouseEnterDelay={mouseEnterDelay}
        mouseLeaveDelay={mouseLeaveDelay}
        onVisibleChange={onOldVisibleChange}
        visible={myVisible}
        destroyTooltipOnHide={destroyTooltipOnHide}
        align={align}
        {...otherProps}
      >
        {wrappedChildren}
      </ReactTooltip>
      {tooltipHelper && (
        <TooltipHelper onShowTooltipChange={onShowTooltipChange}>
          {tooltipHelper}
        </TooltipHelper>
      )}
    </>
  );
}

export default Tooltip;
